import React from 'react';

import {
  promotionSelector,
  usePromotionStore,
} from '@repo/editor/src/stores/promotionStore';
import {
  useUserStore,
  userStoreSelector,
} from '@repo/editor/src/stores/userStore';
import { Badge } from '@repo/ui/components/Badge';
import CrownIcon from '@repo/ui/components/Icon/CrownIcon';
import { Spacer } from '@repo/ui/components/Spacer';

import { FlexRow } from 'styles/layouts';

import { DesignPostProps } from '../types';

import { PremiumTag } from './style';

export const DesignPostTags = ({ post }: { post: DesignPostProps['post'] }) => {
  const proAccess = useUserStore(userStoreSelector.proAccess);

  const showUpgradeModal = usePromotionStore(
    promotionSelector.showUpgradeModal
  );

  const handleClickPremium = () => {
    showUpgradeModal('premiumDesignUsage', {
      designPreview: post.template.templatePreviewObjectName,
      data: {
        templateId: post.template.id,
      },
    });
  };

  if (post.template.premium || post.template.containsAiElement) {
    return (
      <>
        <FlexRow gap="8px">
          {post.template.premium && (
            <PremiumTag onClick={!proAccess ? handleClickPremium : undefined}>
              <CrownIcon height="9px" />
              <span>PREMIUM</span>
            </PremiumTag>
          )}
          {post.template.containsAiElement && (
            <Badge size="s" text="KITTL AI" variant="blue" />
          )}
        </FlexRow>
        <Spacer height="10px" />
      </>
    );
  }
  return null;
};
